import React, { useEffect, useState } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { AiOutlineUserAdd } from "react-icons/ai";
import { AiOutlineFileAdd } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { Tooltip } from "antd";
// import Tooltip from "@mui/material/Tooltip";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { PartnerGetModuleAllocation } from "../../redux/actions/partnerModuleAllocationAction";
import SearchIcon from "@mui/icons-material/Search";
import { NavLink, Link, useHistory, useNavigate } from "react-router-dom";

import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";

import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import BackButton from "../../components/BackButton/BackButton";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

function ModuleAllocation() {
	const navigate = useHistory();
	const classes = useStyles();
	const [role, setRole] = useState("");
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [page, setPage] = useState(0);
	const [getModuleAllocationResStatus, setGetModuleAllocationResStatus] =
		useState(false);
	const [getModuleAllocationResArray, setGetModuleAllocationResArray] =
		useState([]);
	const [isLoading, setIsLoading] = useState(false);

	const dispatch = useDispatch();
	const handleChange = ({ target: { name, value } }) => {
		if (name === "role") {
			setRole(value == "Select Role/Sub Role" ? "" : value);
		}
	};

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	var authToken = regenerateTokenRes.data.AuthToken;

	const partnerModuleAllocationRes = useSelector(
		({ partnerModuleAllocation }) => partnerModuleAllocation
	);

	const getModuleAllocationListApi = () => {
		setGetModuleAllocationResStatus(true);
		setIsLoading(true);
		const req = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				searchRole: role
			}
		};
		return dispatch(
			PartnerGetModuleAllocation(req, regenerateTokenRes.data.AuthToken)
		);
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getModuleAllocationListApi();
		}
	}, [regenerateTokenRes.data.status]);

	const getModuleAllocationListFunc = () => {
		if (getModuleAllocationResStatus) {
			if (partnerModuleAllocationRes.data.status == "success") {
				setGetModuleAllocationResArray(
					[].concat(partnerModuleAllocationRes.data.moduleAllList)
				);
				setIsLoading(false);
			}
			if (partnerModuleAllocationRes.data.status == "failed") {
				setGetModuleAllocationResArray(partnerModuleAllocationRes.data);
				setIsLoading(false);
				if (
					partnerModuleAllocationRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					partnerModuleAllocationRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (partnerModuleAllocationRes.data.status == "Failed") {
				setGetModuleAllocationResArray(partnerModuleAllocationRes.data);
				setIsLoading(false);
				if (
					partnerModuleAllocationRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					partnerModuleAllocationRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		if (getModuleAllocationResStatus) {
			getModuleAllocationListFunc();
		}
	}, [partnerModuleAllocationRes.data.status]);

	useEffect(() => {
		if (partnerModuleAllocationRes.data.status == "Failed") {
			setPage(0);
			if (
				partnerModuleAllocationRes.data.description == "session out"
			) {
				SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
			if (
				partnerModuleAllocationRes.data.description == "Authorization failed"
			) {
				regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
		}
		if (partnerModuleAllocationRes.data.status == "failed") {
			setPage(0);
			if (
				partnerModuleAllocationRes.data.description == "session out"
			) {
				SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
			if (
				partnerModuleAllocationRes.data.description == "Authorization failed"
			) {
				regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
			}
		}
	}, [partnerModuleAllocationRes.data.status]);

	const viewHandleClickOpen = (id) => {
		navigate.push({
			pathname: `/index/getViewConfigurationList`,
			search: `?userId=${id}`
		});
	};

	const updateEditHandleClick = (id) => {
		navigate.push({
			pathname: `/index/getEditConfigurationList`,
			search: `?userId=${id}`
		});
	};

	const moduleAllocationHandleClick = (id, role) => {
		navigate.push({
			pathname: `/index/partnerModuleAllocation`,
			search: `?userId=${id}`,
			state: `${role}`
		});
	};

	return (
		<Layout>
			<Card>
				<Grid
					container
					spacing={2}
					style={{ padding: "25px", marginTop: "2rem" }}
				>
					<Grid item xs={12} sm={12} md={4} lg={4}>
						<TextField
							select
							size="small"
							color="primary"
							autoFocus={true}
							type="text"
							label="Role/Sub Role"
							fullWidth={true}
							name="role"
							defaultValue={"Select Role/Sub Role" || role}
							onChange={handleChange}
							variant="standard"
						>
							<MenuItem
								value="Select Role/Sub Role"
								selected="Select Role/Sub Role"
							>
								Select Role/Sub Role
							</MenuItem>
							<MenuItem value="SUBOWNER">SUBOWNER</MenuItem>
							<MenuItem value="CASHIER">CASHIER</MenuItem>
						</TextField>
					</Grid>

					<Grid item xs={12} sm={12} md={6} lg={6} container>
						<Grid>
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={getModuleAllocationListApi}
							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
						<Grid item md={7}></Grid>
					</Grid>
				</Grid>
			</Card>

			{isLoading ? (
				<LoadingSpinner />
			) : getModuleAllocationResArray.length == undefined ||
				!getModuleAllocationResStatus ? (
				<Card>
					<Grid
						container
						style={{
							padding: "10px"
						}}
					>
						<Grid xs={12} sm={12} md={12} lg={12}>
							<Typography
								variant="body1"
								style={{ fontWeight: "700" }}
								className="themeText"
							>
								Module Allocation
							</Typography>
						</Grid>

						<Grid xs={12} sm={12} md={12} lg={12}>
							<Alert
								className="my-3 tableHeaderColor"
								variant="secondary"
								style={{ color: "white" }}
							>
								No Records Found!
							</Alert>
						</Grid>
					</Grid>
				</Card>
			) : (
				<Card>
					<Grid
						container
						style={{
							padding: "10px"
						}}
					>
						<Grid xs={12} sm={12} md={12} lg={12}>
							<Typography
								variant="body1"
								style={{ fontWeight: "700" }}
								className="themeText"
							>
								Module Allocation
							</Typography>
						</Grid>
						<TableContainer component={Paper} className="my-3">
							<Table
								className={classes.table}
								size="small"
								aria-label="a dense table"
							>
								<TableHead>
									<TableRow className="tableHeaderColor">
										<TableCell
											align="center"
											style={{ fontWeight: "bold", color: "white" }}
										>
											Id
										</TableCell>
										<TableCell
											align="center"
											style={{ fontWeight: "bold", color: "white" }}
										>
											Name
										</TableCell>
										<TableCell
											align="center"
											style={{ fontWeight: "bold", color: "white" }}
										>
											User Name
										</TableCell>
										<TableCell
											align="center"
											style={{ fontWeight: "bold", color: "white" }}
										>
											Email
										</TableCell>
										<TableCell
											align="center"
											style={{ fontWeight: "bold", color: "white" }}
										>
											Mob No
										</TableCell>
										<TableCell
											align="center"
											style={{ fontWeight: "bold", color: "white" }}
										>
											Role/Sub Role
										</TableCell>
										<TableCell
											align="center"
											style={{ fontWeight: "bold", color: "white" }}
										>
											Action
										</TableCell>
									</TableRow>
								</TableHead>

								<TableBody>
									{getModuleAllocationResArray &&
										[]
											.concat(getModuleAllocationResArray)
											.slice(
												page * rowsPerPage,
												page * rowsPerPage + rowsPerPage
											)
											.map((row, index) => (
												<TableRow key={index}>
													<TableCell align="center">
														{row.walletOwnerId}
													</TableCell>
													<TableCell align="center">
														{row.walletOwnerName}
													</TableCell>
													<TableCell align="center">{row.loginName}</TableCell>
													<TableCell align="center">{row.emailFrom}</TableCell>
													<TableCell align="center">{row.mobile}</TableCell>
													<TableCell align="center">{row.subRole}</TableCell>
													<TableCell align="center">
														{/* <Tooltip title="View">
                              <CustomButton
                                style={{
                                  padding: "8px",
                                }}
                                onClick={() => viewHandleClickOpen(row)}
                              >
                                {
                                  <VisibilityIcon
                                    style={{
                                      color: "#fff",
                                      fontSize: "20px",
                                    }}
                                  />
                                }
                              </CustomButton>
                            </Tooltip>

                            <Tooltip title="Edit">
                              <CustomButton
                                style={{
                                  padding: "8px",
                                }}
                                onClick={() =>
                                  updateEditHandleClick(row, "Edit")
                                }
                              >
                                {
                                  <EditIcon
                                    style={{
                                      color: "#fff",
                                      fontSize: "20px",
                                    }}
                                  />
                                }
                              </CustomButton>
                            </Tooltip> */}
														<Tooltip title="Allocate Module">
															<CustomButton
																style={{
																	padding: "8px"
																}}
																onClick={() =>
																	moduleAllocationHandleClick(
																		row.walletOwnerId,
																		row.subRole,
																		"Module"
																	)
																}
															>
																Allocate Module
															</CustomButton>
														</Tooltip>
													</TableCell>
												</TableRow>
											))}
								</TableBody>
							</Table>
							<TablePagination
								rowsPerPageOptions={[5, 10, 25]}
								component="div"
								count={getModuleAllocationResArray.length}
								rowsPerPage={rowsPerPage}
								page={page}
								onPageChange={handleChangePage}
								onRowsPerPageChange={handleChangeRowsPerPage}
							/>
						</TableContainer>
					</Grid>
				</Card>
			)}
		</Layout>
	);
}

export default ModuleAllocation;
